const m = require('air-vue-model')()
m.url = 'order_review_tags'
m.name = 'orderReviewTag'

m.text = {
    listTitle: 'Категории отзывов'
}

m.default = {
    title: '',
    color: '#fab400',
    active: true,
    sorting: 0,
    group: null,
    ratings: [],
    pickup_types: [],
    service: false
}

m.filters = {
    active: true,
    pickup_type: null,
    rating: null,
    service: false
}



m.routes = [
    {
        name: 'list',
        component: require('@/admin/views/orderReviewTags/OrderReviewTags.vue'),
    },
]

module.exports = m